<template xmlns:v-lazy="http://www.w3.org/1999/xhtml">
  <hooper
    ref="carousel"
    class="buy-similar-slider"
    :itemsToShow="itemsPerPage"
    :itemsToSlide="1"
    :initialSlide="2"
    :centerMode="false"
    :wheelControl="false"
    :mouseDrag="false"
    :shortDrag="false"
    @slide="onSlide"
  >
    <slide v-for="item in similarList" :key="item.id">
      <div class="slide-item">
        <div class="slide-item-inner" @click="viewDetail(item.uniqueTitle)">
          <div class="img" v-lazy:background-image="item.gallery[0].url">
            <div class="price">{{ getCurrency(item) }} {{ item.price }}</div>
          </div>
          <div class="title">{{ item.subTitle }}</div>
          <div class="addr">{{ item.title }}</div>
        </div>
      </div>
    </slide>

    <hooper-navigation slot="hooper-addons"></hooper-navigation>
  </hooper>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  props: {
    itemsPerPage: {
      type: Number,
      default: 3,
    },
    list: Array,
    initIndex: {
      type: Number,
      default: 0,
    },
    centerMode: {
      type: Boolean,
      default: false,
    },
    similarList: Array,
  },
  data() {
    return {
      nearbyImg: require('@/assets/images/home-sell.jpg'),
      itemList: [],
    }
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
  methods: {
    setCur(i) {
      this.$refs.carousel.slideTo(i)
    },
    onSlide(currentSlide, slideFrom) {
      this.$emit('slide', currentSlide, slideFrom)
    },
    getCurrency(item) {
      if (item.currency === 'RMB') {
        return '￥'
      }
      return '$'
    },
    viewDetail(uniqueTitle) {
      window.open(`/sell/detail/${uniqueTitle}`)
    },
  },
  watch: {
    imgs: function(val) {
      this.itemList = val || []
      setTimeout(() => {
        this.setCur(this.initIndex)
      }, 100)
    },
  },
}
</script>

<style lang="less">
/* global */
.buy-similar-slider {
  height: 260px;
  outline: none;

  .hooper-slide {
    text-align: right;
  }
  .hooper-prev,
  .hooper-next {
    background: rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 4px;
    outline: none;
    margin-top: -20px;
  }
  .hooper-next {
    right: 38px;
  }
}
</style>

<style lang="less" scoped>
.slide-item {
  width: 332px;
}
.slide-item-inner {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  height: 255px;
  width: 283px;
  border-radius: 6px;
  text-align: left;

  .img {
    position: relative;
    height: 177px;
    width: 283px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }
  .price {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #99d20d;
    width: 112px;
    height: 25px;
    line-height: 25px;
    border-radius: 4px 0 0 0;
    text-align: center;
    color: #fff;
  }
  .title {
    margin-top: 12px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .addr {
    margin-top: 12px;
    color: rgba(0, 0, 0, 0.5);
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
